(function () {
    'use strict';
    var controllerId = 'alertListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', alertListCtrl]);

    function alertListCtrl(common, datacontext, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.alert = {};

        vm.alert_type_id = "";
        vm.alert_subtype_id = "";
        vm.alert_status_id = "1";
        vm.alert_limit = 1000;

        vm.alertLimits = [
            { key: '10', value: '10' },
            { key: '50', value: '50' },
            { key: '100', value: '100' },
            { key: '500', value: '500' },
            { key: '1000', value: '1000' },
            { key: '5000', value: '5000' }
        ];


        activate();

        $scope.filterStatus = function () {
            vm.alert_status_id = $scope._status;
            getAlerts();
        };

        $scope.filterSubtype = function () {
            vm.alert_subtype_id = $scope._subType;
            getAlerts();
        };

        $scope.filterLimit = function () {
            vm.alert.limit = $scope.alert.limit;
            getAlerts();
        };

        $scope.updateStatus = function (data, idx) {
            data = {
                alert_subtype_link_id : data.alert_subtype_link_id,
                status_id: data.status_id,
                idx: idx
            };


            return datacontext.update_alert_link(data).then(function (httpResult) {
                // refresh query?
                vm.alert_log.splice(data.idx, 1);

            });

        };

        function activate() {
            var promises = [getAlerts(), getAlertStatus(), getAlertSubTypes()];
            common.activateController(promises, controllerId)
                .then(function () {
                    //  log('Activated Location List View');
                });
        }

        function getAlerts() {
            var filter = {
                alert_type_id: vm.alert_type_id,
                alert_subtype_id: vm.alert_subtype_id,
                status_id: vm.alert_status_id,
                limit: vm.alert_limit
            };

            return datacontext.getAlertLog(filter).then(function (httpResult) {
                vm.alert_log = httpResult.data.data;
            });
        }

        function getAlertSubTypes() {

            var filter = {
                alert_type_id: vm.alert_type_id
            };


            return datacontext.getAlertSubTypes(filter).then(function (httpResult) {
                vm.alert_subtypes = httpResult.data.data;
            });
        }

        function getAlertStatus() {

            var filter = {
                alert_status_id: vm.alert_status_id
            };

            return datacontext.getAlertStatus(filter).then(function (httpResult) {
                vm.alert_status = httpResult.data.data;

            });
        }

    }
})();